import api from '@/libs/axios'
import { AccesPlateformeBeneficiaire, PriseRdvConfigurationModel, NewsConfigModel, ApplicationsConfigModel, SmsConfigModel } from '../models/accesPlateformeBeneficiaires/accesPlateformeBeneficiaire';

const resource = 'AccesPlateformeBeneficiaire'

export default class AccesPlateformeBeneficiairesRessource {

  public async downloadFlyer(id: string): Promise<Blob> {
    const response = await api.get(`${resource}/${id}/generateFlyer`, { responseType: 'blob' });
    return response.data;
  }

  public async getByCode(codeInscription: string): Promise<AccesPlateformeBeneficiaire> {
    const response = await api.get(`${resource}/${codeInscription}`);
    return response.data;
  }
  
  public async post(data : AccesPlateformeBeneficiaire) : Promise<AccesPlateformeBeneficiaire> {
    const response = await api.post(`${resource}`, data)
    return response.data
  }

  public async update(id: string, data : AccesPlateformeBeneficiaire) : Promise<AccesPlateformeBeneficiaire> {
    const response = await api.put(`${resource}/${id}`, data)
    return response.data
  }

  public async updatePriseDeRdv(id: string, data? : PriseRdvConfigurationModel | null) : Promise<string> {
    const response = await api.put(`${resource}/${id}/PriseDeRdvConfig`, data);
    return response.data;
  }

  public async syncPriseDeRdvConfig(id: string) : Promise<string> {
    const response = await api.post(`${resource}/${id}/SyncPriseDeRdvConfig`);
    return response.data;
  }

  public async updateNewsConfig(id: string, data? : NewsConfigModel | null) : Promise<string> {
    const response = await api.put(`${resource}/${id}/NewsConfig`, data);
    return response.data;
  }

  public async syncNewsConfig(id: string): Promise<string> {
    const response = await api.post(`${resource}/${id}/SyncNewsConfig`);
    return response.data;
  }

  public async updateApplicationsConfig(id: string, data? : ApplicationsConfigModel | null) : Promise<string> {
    const response = await api.put(`${resource}/${id}/ApplicationsConfig`, data);
    return response.data;
  }

  public async syncApplicationsConfig(id: string): Promise<string> {
    const response = await api.post(`${resource}/${id}/SyncApplicationsConfig`);
    return response.data;
  }

  public async updateSmsConfig(id: string, data? : SmsConfigModel | null) : Promise<string> {
    const response = await api.put(`${resource}/${id}/SmsConfig`, data);
    return response.data;
  }

  public async syncSmsConfig(id: string): Promise<string> {
    const response = await api.post(`${resource}/${id}/SyncSmsConfig`);
    return response.data;
  }
}